import React from 'react';
import { Award, Target, Users, Zap } from 'lucide-react';
import { aboutUs } from '../data/mock';

export const About = () => {
  const values = [
    {
      icon: Target,
      title: 'Compromiso',
      description: 'Dedicados a entregar soluciones de calidad que superen las expectativas de nuestros clientes.'
    },
    {
      icon: Award,
      title: 'Profesionalismo',
      description: 'Trabajamos con los más altos estándares de calidad y excelencia operativa.'
    },
    {
      icon: Users,
      title: 'Enfoque al Cliente',
      description: 'Cada proyecto es único y lo abordamos con atención personalizada y dedicada.'
    },
    {
      icon: Zap,
      title: 'Eficiencia',
      description: 'Soluciones rápidas y confiables que optimizan tiempo y recursos.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white via-slate-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {aboutUs.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#01A9DB] to-[#F58020] mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-slate-600">
            Conoce nuestra historia y compromiso con la excelencia
          </p>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Left: Text Content */}
          <div className="space-y-6">
            {aboutUs.content.map((paragraph, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-cyan-200 group"
              >
                <p className="text-slate-700 leading-relaxed text-lg group-hover:text-slate-900 transition-colors">
                  {paragraph}
                </p>
              </div>
            ))}
          </div>

          {/* Right: Image with Stats */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzfGVufDB8fHx8MTc3Mzk3MDkzOXww&ixlib=rb-4.1.0&q=85"
                alt="Equipo Bramador"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
              
              {/* Floating Stats Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-md rounded-xl p-6 shadow-2xl">
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-[#01A9DB] mb-1">2020</div>
                    <div className="text-sm text-slate-600 font-medium">Fundación</div>
                  </div>
                  <div className="text-center border-l border-slate-200">
                    <div className="text-3xl font-bold text-[#F58020] mb-1">100%</div>
                    <div className="text-sm text-slate-600 font-medium">Satisfacción</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-sky-500/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-blue-500/10 rounded-full blur-3xl"></div>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:border-cyan-200 hover:-translate-y-2"
            >
              {/* Icon Background */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#01A9DB]/10 to-[#F58020]/10 rounded-full -mr-16 -mt-16 group-hover:scale-110 transition-transform duration-300"></div>
              
              {/* Icon */}
              <div className="relative mb-4 inline-flex">
                <div className="w-14 h-14 bg-gradient-to-br from-[#01A9DB] to-[#F58020] rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300">
                  <value.icon className="w-7 h-7 text-white" />
                </div>
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-[#01A9DB] transition-colors">
                {value.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
